import classnames from 'classnames'
import React from 'react'
import styled from 'styled-components'

const StyledStickyWrapper = styled.div<{ position: 'fixed' | 'sticky' }>`
  position: ${props => props.position};
  top: -100%;
  width: 100%;
  z-index: 0;
  opacity: 0;

  transition: all 0.2s ease-in-out;

  &.visible {
    z-index: 100;
    opacity: 1;
    top: 0;
  }
`

type Props = {
  children: React.ReactNode | React.ReactNode[]
  visible: boolean
  position: 'fixed' | 'sticky'
}

const StickyWrapperComponent = ({ children, visible, position }: Props, ref: any) => (
  <StyledStickyWrapper ref={ref} className={classnames('qa--sticky-wrapper', { visible })} position={position}>
    {children}
  </StyledStickyWrapper>
)

export const StickyWrapper = React.forwardRef(StickyWrapperComponent)
